/**
 * Select — themeable native <select> (Claude Design `.select`).
 *
 * Native (not Radix): native selects are accessible, keyboard-friendly, and
 * avoid pulling in another popover layer for simple option lists. 34px tall,
 * `surface-2` fill with a `surface` fill on focus, and an inline-SVG caret.
 */
import { forwardRef, type SelectHTMLAttributes } from 'react';

import { cn } from './cn.js';

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, children, ...props }, ref) => (
    <select
      ref={ref}
      className={cn(
        'h-[34px] w-full appearance-none rounded-md border border-border bg-surface-2 py-2 pl-[11px] pr-[30px] ' +
          'text-[13px] leading-[1.4] text-text transition',
        'focus-visible:outline-none focus:border-primary-line focus:bg-surface',
        'disabled:cursor-not-allowed disabled:opacity-50',
        // Caret drawn as an inline SVG background so it themes with currentColor.
        "bg-[url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%2212%22 height=%2212%22 viewBox=%220 0 24 24%22 fill=%22none%22 stroke=%22gray%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22><path d=%22M6 9l6 6 6-6%22/></svg>')]",
        'bg-[length:12px] bg-[right_11px_center] bg-no-repeat',
        className,
      )}
      {...props}
    >
      {children}
    </select>
  ),
);
Select.displayName = 'Select';
